const fr = {
  appName: "HANA",
  tagline: "Suivi médical sécurisé",
  loading: "Chargement...",
  error: "Une erreur est survenue",
  save: "Enregistrer",
  cancel: "Annuler",
  confirm: "Confirmer",
  delete: "Supprimer",
  edit: "Modifier",
  back: "Retour",
  next: "Suivant",
  previous: "Précédent",
  submit: "Soumettre",
  close: "Fermer",
  search: "Rechercher",
  noData: "Aucune donnée",
  yes: "Oui",
  no: "Non",
  refresh: "Actualiser",
  all: "Tous",
  actions: "Actions",
  details: "Détails",
  view: "Voir",
  add: "Ajouter",
  create: "Créer",
  update: "Mettre à jour",
  filter: "Filtrer",
  export: "Exporter",
  print: "Imprimer",
  download: "Télécharger",
  upload: "Téléverser",
  required: "Obligatoire",
  optional: "Optionnel",
  active: "Actif",
  inactive: "Inactif",
  enabled: "Activé",
  disabled: "Désactivé",
  success: "Succès",
  warning: "Attention",
  info: "Information",
  
  // Login page
  login: {
    welcome: "Connexion",
    connectToSpace: "",
    professional: "Professionnel",
    patient: "Patient",
    email: "Adresse email",
    password: "Mot de passe",
    phone: "Numéro de téléphone",
    connect: "Se connecter",
    forgotPassword: "Mot de passe oublié ?",
    forgotPasswordTitle: "Mot de passe oublié",
    forgotPasswordDesc: "Entrez votre email pour recevoir un lien",
    forgotPasswordPatientDesc: "Contactez votre clinique pour réinitialiser",
    sendLink: "Envoyer le lien",
    requestReset: "Demander réinitialisation",
    backToLogin: "Retour à la connexion",
    enterPhoneAndPassword: "Veuillez entrer votre numéro et mot de passe",
    enterEmail: "Veuillez entrer votre email",
    enterPhone: "Veuillez entrer votre numéro de téléphone",
    recoveryEmailSent: "Email de récupération envoyé",
    recoveryLinkSent: "Lien de récupération envoyé",
    heroTitle: "Votre suivi oncologique,",
    heroSubtitle: "mieux coordonné entre deux passages à l’hôpital",
    heroDescription: "Hana aide patients, proches et équipes soignantes à garder une information claire : symptômes, messages, documents, traitements oraux, rendez-vous et suivi inter-cure.",
    featureSecure: "Accès sécurisé selon le rôle de chacun",
    featurePersonalized: "Suivi patient simple, rassurant et accessible",
    featureRealtime: "Coordination clinique plus lisible pour l’équipe",
    copyright: "© 2026 HANA Medical. Tous droits réservés.",
    emergencyTitle: "Urgence :",
    emergencyText: "si la situation est grave ou rapide, allez à l’hôpital le plus proche ou appelez le",
    emergencyPhone: "141",
    // New auth flow translations
    loginButton: "Se connecter",
    success: "Connexion réussie",
    trustedDeviceLogin: "Connexion via appareil de confiance",
    verify2FA: "Vérification en deux étapes",
    enter2FACode: "Entrez le code reçu par email",
    enter6DigitCode: "Veuillez entrer le code à 6 chiffres",
    trustThisDevice: "Faire confiance à cet appareil (30 jours)",
    verifyCode: "Vérifier le code",
    deviceTrusted: "Appareil enregistré comme appareil de confiance",
    changePasswordTitle: "Changement de mot de passe",
    firstLoginChangePassword: "Pour des raisons de sécurité, vous devez changer votre mot de passe à la première connexion.",
    newPassword: "Nouveau mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    passwordsDoNotMatch: "Les mots de passe ne correspondent pas",
    passwordMinLength: "Le mot de passe doit contenir au moins 8 caractères",
    passwordRequirements: "Le mot de passe doit contenir au moins 8 caractères",
    changePasswordButton: "Changer le mot de passe",
    patientLogin: "Connexion Patient",
    hanaAccess: "Accès Hana",
    rememberEmail: "Se souvenir de mon adresse",
    rememberMe: "Se souvenir de moi",
    continue: "Continuer",
    useHanaCode: "Utiliser mon code Hana",
    touchIdFaceId: "Touch ID / Face ID",
    enterPhoneForOTP: "Entrez votre numéro de téléphone pour recevoir un code par SMS",
    phoneNumber: "Numéro de téléphone",
    sendOTP: "Envoyer le code",
    verifyOTP: "Vérification du code",
    otpSentToWhatsApp: "Un code a été envoyé par SMS au numéro",
    verifyOTPButton: "Vérifier",
    changeNumber: "Changer de numéro",
    resendOTP: "Renvoyer le code",
    resetPassword: "Réinitialiser le mot de passe",
    resetPasswordInstructions: "Entrez votre email pour recevoir un lien de réinitialisation",
    sendResetLink: "Envoyer le lien",
    resetEmailSent: "Si cet email existe, un lien de réinitialisation a été envoyé",
    platformDescription: "Plateforme de télésuivi oncologique sécurisée",
    secure: "Sécurisé",
    monitoring: "Suivi",
    care: "Soins",
    allRightsReserved: "Tous droits réservés",
  },

  resetPassword: {
    title: "Nouveau mot de passe",
    instructions: "Créez un nouveau mot de passe sécurisé pour votre compte.",
    newPassword: "Nouveau mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    requirements: "Le mot de passe doit contenir au moins 8 caractères",
    resetButton: "Réinitialiser le mot de passe",
    passwordsDoNotMatch: "Les mots de passe ne correspondent pas",
    passwordMinLength: "Le mot de passe doit contenir au moins 8 caractères",
    success: "Mot de passe réinitialisé",
    successDesc: "Votre mot de passe a été modifié avec succès. Vous pouvez maintenant vous connecter.",
    goToLogin: "Se connecter",
    invalidLink: "Lien invalide",
    invalidLinkDesc: "Ce lien de réinitialisation n'est pas valide. Veuillez faire une nouvelle demande.",
    linkExpired: "Lien expiré",
    linkExpiredDesc: "Ce lien de réinitialisation a expiré. Veuillez faire une nouvelle demande.",
    requestNewLink: "Demander un nouveau lien",
    backToLogin: "Retour à la connexion",
  },

  auth: {
    login: "Connexion",
    logout: "Déconnexion",
    email: "Adresse email",
    password: "Mot de passe",
    phone: "Numéro de téléphone",
    forgotPassword: "Mot de passe oublié ?",
    resetPassword: "Réinitialiser",
    otpCode: "Code OTP",
    twoFACode: "Code d'authentification",
    loginStaff: "Connexion Professionnel",
    loginPatient: "Connexion Patient",
    welcomeBack: "Bon retour",
    enterCredentials: "Entrez vos identifiants",
    staffPortal: "Portail Professionnel",
    patientPortal: "Espace Patient",
    twoFARequired: "Authentification à deux facteurs",
    twoFADesc: "Entrez le code de votre application d'authentification",
    otpDesc: "Un code a été envoyé à votre téléphone",
    verify: "Vérifier",
    firstLogin: "Première connexion",
  },

  roles: {
    SUPER_ADMIN_SAAS: "Super Administrateur",
    ADMIN_GROUPE: "Administrateur Groupe",
    ADMIN_CLINIQUE: "Administrateur Clinique",
    MEDECIN: "Médecin",
    IDE: "Infirmier(ère)",
    SECRETAIRE_MEDICAL: "Secretariat Medical",
    PATIENT: "Patient",
  },

  status: {
    STABLE: "Stable",
    OPEN_ALERT: "Alerte ouverte",
    TO_MONITOR: "À surveiller",
    CRITICAL: "Critique",
    HOSPITALIZED: "Hospitalisé",
  },

  alertLevel: {
    VERT: "Normal",
    JAUNE: "Attention",
    ORANGE: "Avertissement",
    CRITICAL: "Critique",
  },

  checkin: {
    title: "Dire mes symptômes",
    subtitle: "",
    pageUrgent: "Signes à signaler",
    pageUrgentDesc: "Indiquez tout signe inhabituel présent maintenant.",
    pageMain: "Symptômes",
    pageMainDesc: "Choisissez le niveau le plus proche.",
    pageVitalsDesc: "Renseignez uniquement les mesures disponibles.",
    urgentWarning: "À sélectionner si présent maintenant",
    alreadyDone: "Déjà envoyé aujourd’hui",
    alreadyDoneDesc: "",
    reportProblem: "Signaler un problème",
    submitSuccess: "Envoyé",
    submitting: "Envoi…",
    noUrgent: "Aucun signe urgent",
    step: "Étape",
    of: "sur",
    urgentQuestions: "Signes cliniques",
    urgentQuestionsDesc: "Répondez oui ou non. En cas de doute, choisissez oui.",
    urgentDetected: "L’équipe sera informée.",
    howDoYouFeel: "Symptômes",
    chooseFace: "Choisissez ce que vous ressentez",
    lastStep: "Mes chiffres",
    lastStepDesc: "",
    finish: "Envoyer mon check-in",
    sending: "Envoi…",
    backHome: "Accueil",
    pageSymptoms: "Symptômes",
    pageVitals: "Mes chiffres",
    symptomsIntro: "Symptômes",
    symptomsIntroDesc: "Choisissez ce que vous ressentez",
    nothingToReport: "Je vais bien, rien à signaler",
    nothingToReportHint: "Passer directement à mes chiffres (facultatif)",
    vitalsOptional: "Mes chiffres (facultatif)",
    skipVitalsSend: "Je n'ai pas de chiffres à saisir — Envoyer mon check-in",
    backToSymptoms: "Modifier mes symptômes",
    backHomeTop: "Retour à l'accueil",
    symptoms: {
      fatigue: "Fatigue",
      pain: "Douleur",
      nausea: "Nausées / Vomissements",
      diarrhea: "Diarrhée",
      constipation: "Constipation",
      dyspnea: "Difficultés respiratoires",
      appetite: "Perte d'appétit",
      neuropathy: "Fourmillements / Engourdissements",
      mucositis: "Douleur bouche / Aphtes",
      rash: "Rash cutané / Problèmes de peau",
      bleeding: "Saignements inhabituels",
      edema: "Gonflements / Oedèmes",
      perceivedFever: "Fièvre ressentie / Frissons",
      cough: "Toux",
      joint_pain: "Douleurs articulaires",
      hot_flashes: "Bouffées de chaleur",
      sleep_issues: "Troubles du sommeil",
      pruritus: "Démangeaisons / Peau sèche",
      infection_signs: "Signes infectieux",
    },
    grades: {
      fatigue: ["Aucune", "Légère", "Modérée", "Importante"],
      pain: ["Aucune", "Légère", "Modérée", "Forte"],
      nausea: ["Aucune", "Légère", "Vomissements", "Répétés"],
      diarrhea: ["Normal", "Molles", "Liquides", "Sévère"],
      constipation: ["Normal", "Légère", "Gênante", "Sévère"],
      dyspnea: ["Aucune", "À l'effort", "Effort min.", "Au repos"],
      appetite: ["Normal", "Réduit", "Très peu", "Plus rien"],
      neuropathy: ["Aucun", "Léger", "Modéré", "Important"],
      mucositis: ["Aucune", "Inconfort", "Gêne repas", "Alimentation impossible"],
      rash: ["Aucun", "Rougeurs", "Étendu", "Sévère"],
      bleeding: ["Aucun", "Traces", "Modéré", "Abondant"],
      edema: ["Aucun", "Léger", "Visible", "Important"],
      perceivedFever: ["Aucune", "Chaleur", "Fièvre", "Frissons"],
      cough: ["Aucune", "Légère", "Gênante", "Importante"],
      joint_pain: ["Aucune", "Légère", "Gênante", "Forte"],
      hot_flashes: ["Aucune", "Légères", "Gênantes", "Très fortes"],
      sleep_issues: ["Aucun", "Léger", "Gênant", "Important"],
      pruritus: ["Aucun", "Léger", "Gênant", "Sévère"],
      infection_signs: ["Aucun", "Léger", "Présent", "Important"],
    },
    audioMessages: {
      step1_intro: "Indiquez votre état actuel. Choisissez le niveau le plus proche.",
      fatigue: "Ressentez-vous de la fatigue ?",
      pain: "Ressentez-vous une douleur ?",
      nausea: "Avez-vous des nausées ou des vomissements ?",
      diarrhea: "Avez-vous de la diarrhée ?",
      constipation: "Êtes-vous constipé ?",
      dyspnea: "Avez-vous des difficultés à respirer ?",
      appetite: "Votre appétit est-il diminué ?",
      neuropathy: "Avez-vous des fourmillements ou des engourdissements ?",
      mucositis: "Avez-vous mal à la bouche ou des aphtes ?",
      rash: "Avez-vous des problèmes de peau ?",
      bleeding: "Avez-vous des saignements inhabituels ?",
      edema: "Avez-vous des gonflements ou des oedèmes ?",
      perceivedFever: "Ressentez-vous de la fièvre ou des frissons ?",
      cough: "Avez-vous de la toux ?",
      joint_pain: "Avez-vous des douleurs articulaires ?",
      hot_flashes: "Avez-vous des bouffées de chaleur ?",
      sleep_issues: "Avez-vous des troubles du sommeil ?",
      pruritus: "Avez-vous des démangeaisons ou la peau sèche ?",
      infection_signs: "Avez-vous des signes infectieux ?",
      step2_intro: "Ajoutez les mesures disponibles, puis validez.",
      temperature: "Quelle est votre température ?",
      heartRate: "Quel est votre pouls ?",
      bloodPressure: "Quelle est votre tension artérielle ?",
      spo2: "Quelle est votre saturation en oxygène ?",
      weight: "Quel est votre poids ?",
    },
    severity: {
      0: "Aucun",
      1: "Léger",
      2: "Modéré",
      3: "Sévère",
    },
    vitals: {
      temperature: "Température",
      heartRate: "Pouls",
      spo2: "Oxygène (SpO2)",
      weight: "Poids",
      bloodPressure: "Tension artérielle",
      systole: "Haut",
      diastole: "Bas",
    },
    pageObservance: "Observance",
    observanceIntro: "Traitement",
    observanceIntroDesc: "Réponse rapide sur votre prise.",
    observance: {
      treatmentTaken: "Avez-vous pris votre traitement ?",
      yes: "Oui",
      partial: "Partiellement",
      no: "Non",
      missedDoses: "Avez-vous oublié des prises ?",
      noMissed: "Aucun",
      occasional: "Occasionnels",
      frequent: "Fréquents",
    },
    qol: {
      title: "Qualité de vie aujourd’hui",
      good: "Bonne",
      average: "Moyenne",
      poor: "Altérée",
      veryPoor: "Très altérée",
    },
    result: {
      titleVert: "Suivi envoyé",
      descVert: "Merci. Votre équipe pourra consulter vos réponses.",
      titleOrange: "À revoir par l’équipe",
      descOrange: "Votre équipe va vérifier vos réponses.",
      titleRouge: "Alerte transmise",
      descRouge: "Votre équipe est alertée. En danger immédiat : 141.",
      detailsLabel: "Éléments envoyés :",
      treatmentDay: "Jour de traitement",
      cycle: "Cycle",
      backHome: "Retour à l'accueil",
    },
    errors: {
      networkLost: "Connexion perdue",
      networkLostFull: "Connexion perdue. Vos réponses sont sauvegardées, vous pouvez réessayer.",
      unavailable: "Service indisponible",
      unavailableFull: "Service temporairement indisponible. Réessayez dans quelques instants.",
      retryHint: "Vos réponses sont sauvegardées. Appuyez sur Réessayer.",
      retry: "Réessayer",
    },
    questionnaire: {
      intro: "Questionnaire complémentaire. Durée estimée : {n} minutes.",
      introPrefix: "Questionnaire complémentaire. Durée estimée :",
      introSuffix: "minutes.",
      skip: "Passer",
      send: "Envoyer",
      thanks: "Réponses envoyées",
      loadError: "Questionnaire indisponible",
      vasMin: "0 - Très altéré",
      vasMax: "100 - Excellent",
      label: "Questionnaire",
    },
  },

  patient: {
    greeting: "Bonjour",
    todayTitle: "Aujourd’hui",
    checkIn: "Comment je me sens",
    checkInDone: "Suivi du jour envoyé",
    nextAppointment: "Prochain rendez-vous",
    contactNurse: "Message à l’équipe",
    medicalRecord: "Documents médicaux",
    noAppointment: "Aucun rendez-vous prévu",
    myStatus: "Aujourd'hui",
    myTreatment: "Mon traitement",
    myPathology: "Mon parcours",
    pushNotifications: "Rappels",
    pushEnabled: "Rappel quotidien actif",
    pushDisabled: "Rappels inactifs",
    pushTest: "Tester",
    pushTesting: "Envoi...",
    pushDisable: "Désactiver",
    pushDeactivated: "Notifications désactivées",
    pushEnable: "Activer",
    pushSent: "Notification envoyée.",
    pushNoSend: "Aucune notification envoyée.",
    pushError: "Erreur lors du test.",
    pushActivated: "Rappels activés",
    pushActivateError: "Activation impossible. Vérifiez les permissions du navigateur.",
    loadError: "Profil indisponible. Veuillez réessayer.",
    notSpecified: "Non renseigné",
    uploadResults: "Envoyer mon bilan",
    homeReassurance: "Voici les actions utiles pour votre suivi.",
    dailyRitualLabel: "À retenir",
    dailyRitualTitle: "En cas d’urgence, j’appelle. Pour mon suivi, j’utilise Hana.",
    dailyRitualDesc: "Message ou document non urgent : passez par Hana.",
    todayActions: "À faire aujourd’hui",
    showMore: "Voir plus",
    showLess: "Voir moins",
    careContextLabel: "Suivi",
    careContextText: "Un suivi partagé avec votre équipe soignante.",
    pendingQuestionsLabel: "Questionnaire à compléter",
    pendingQuestionsCount: "{n} questionnaire{s}",
    touchToStart: "Commencer",
    nav: {
      home: "Accueil",
      followup: "Suivi",
      team: "Équipe",
      folder: "Dossier",
      messages: "Mes échanges",
      questionnaires: "Questionnaires",
      documents: "Mes documents",
    },
    journey: {
      title: "Aujourd’hui",
      heroKicker: "À faire maintenant",
      firstThing: "À faire maintenant",
      sayHowIFeel: "Dire mes symptômes",
      reportProblem: "Signaler un problème",
      actionToday: "Une réponse courte pour l’équipe",
      answerQuestions: "Répondre aux questions",
      confirmTreatment: "Confirmer mon médicament",
      nothingUrgent: "Rien à faire maintenant",
      teamKeepsTrack: "",
      yourPath: "Les étapes de mon suivi",
      healthNews: "Dire mes symptômes",
      done: "Fait",
      toDo: "À faire",
      questions: "Répondre aux questions",
      noneForNow: "Rien à remplir pour le moment",
      ok: "OK",
      homeTreatment: "Confirmer mon médicament",
      treatmentToComplete: "{n} prise(s)",
      treatmentUpToDate: "Confirmé",
      noHomeTreatment: "Rien à confirmer",
      planned: "Prévu",
      none: "—",
      toConfirm: "À confirmer",
      myTeam: "Écrire à l’équipe",
      myAppointments: "Voir mes rendez-vous",
      unreadMessages: "{n} message(s) à lire",
      writeIfNeeded: "Écrire si besoin hors urgence",
      available: "Ouvert",
      sendBilanSubtitle: "Photo ou PDF avant traitement",
      send: "Envoyer",
      myFolder: "Voir mes documents",
      documentsAndResults: "Documents et résultats rangés ici",
      open: "Ouvrir",
      advice: "Lire mes conseils",
      shortAdvice: "À lire quand vous avez le temps",
      read: "Lire",
      careToday: "Ce que je dois faire",
      pendingShort: "à faire",
      myServices: "Autres actions",
      quickAccess: "simple et direct",
    },
    audio: {
      listen: "Écouter",
    },
    audioMessages: {
      home_symptoms: "Check-in. Dites simplement comment vous vous sentez aujourd’hui.",
      home_report_problem: "Signaler un problème. Utilisez ce bouton si quelque chose change en dehors du check-in prévu.",
      home_questions: "Mes questionnaires. Répondez aux questions médicales prévues, une question à la fois.",
      home_medicine: "Mon traitement. Confirmez si vous avez pris votre traitement à domicile.",
      home_bilan: "Envoyer mes résultats. Envoyez ici vos bilans pré-chimio pour l’équipe infirmière.",
      home_team: "Écrivez à l’équipe pour une question non urgente.",
      home_documents: "Mon dossier. Consultez vos documents, ou ajoutez un document médical autre que le bilan pré-chimio.",
      home_appointments: "Consultez vos rendez-vous.",
      home_advice: "Éducation. Retrouvez des conseils utiles pour mieux comprendre votre suivi.",
      home_emergency: "En cas de danger, appelez le 141 ou allez à l’hôpital.",
    },
    statusNotes: {
      STABLE: "Votre suivi ne montre pas de signal particulier pour le moment.",
      OPEN_ALERT: "Votre équipe a une alerte ouverte à vérifier.",
      TO_MONITOR: "Votre équipe suit votre situation avec attention.",
      CRITICAL: "Votre équipe est prévenue et suit votre situation de près.",
      HOSPITALIZED: "Votre suivi est adapté avec l’équipe sur place.",
    },
    statusLabels: {
      CRITICAL: "Suivi rapproché",
    },
    oralAdherence: {
      title: "Traitement oral",
      subtitle: "Validez uniquement la prise prévue aujourd’hui.",
      scheduledDate: "Prise prévue",
      savedTaken: "Prise confirmée",
      savedNotTaken: "Information envoyée",
      saveError: "Cette prise n’est pas à valider maintenant",
      upToDate: "Prise du jour validée. Prochaine validation à la prochaine prise.",
      todayChip: "Aujourd’hui",
      takenShort: "Pris",
      notTakenShort: "Non",
      extraCount: "{n} autre prise à valider.",
      extraCountPlural: "{n} autres prises à valider.",
    },
    layout: {
      legal: "Documents juridiques",
      logout: "Déconnexion",
      emergencyPrefix: "Urgence :",
      emergencyAppNotice: "appelez le 141 ou allez à l’hôpital.",
      emergencyActionBeforePhone: "",
      emergencyPhoneLabel: "141",
      pushTitle: "Activer les rappels",
      pushDesc: "Recevoir un rappel quotidien.",
      pushActivate: "Activer",
    },
    questionnaires: {
      title: "Questions",
      subtitle: "",
      backList: "Retour",
      backHome: "Accueil",
      loadError: "Chargement impossible",
      completed: "Envoyé",
      emptyTitle: "Aucune question",
      emptyDesc: "",
      visit: "Visite",
      due: "Prévu le",
    },
    frequency: {
      title: "Suivi prévu",
      DAILY: "tous les jours",
      EVERY_2_DAYS: "tous les 2 jours",
      "3X_WEEK": "3 fois par semaine",
      "1X_WEEK": "1 fois par semaine",
      upToDate: "À jour",
      nextToday: "aujourd’hui",
      nextTomorrow: "demain",
      nextFewDays: "dans les prochains jours",
      nextThisWeek: "cette semaine",
      notToday: "pas aujourd’hui",
      nextCheckin: "Prochain suivi",
    },
  },

  nurse: {
    dashboard: "Tableau de bord",
    patientList: "Mes patients",
    todayAlerts: "Alertes du jour",
    criticalPatients: "Patients critiques",
    monitorPatients: "À surveiller",
    stablePatients: "Stables",
    hospitalizedPatients: "Hospitalisés",
    noCheckin48h: "Sans check-in >48h",
    unreadMessages: "Messages non lus",
    noAlerts: "Aucune alerte active",
    lastCheckin: "Dernier check-in",
    assignAlert: "Prendre en charge",
    resolveAlert: "Résoudre",
    escalateAlert: "Escalader",
    writeTransmission: "Écrire une transmission",
    changeStatus: "Changer le statut",
    transmission: "Transmission",
    transmissionRequired: "Une transmission est obligatoire",
    priorityPatients: "Patients prioritaires",
    noPriorityPatients: "Aucun patient prioritaire",
    viewAll: "Voir tous",
  },

  doctor: {
    dashboard: "Tableau de bord",
    criticalPatients: "Patients critiques",
    pendingRequests: "Demandes IDE",
    escalatedAlerts: "Alertes escaladées",
    pendingValidations: "À valider",
    writePrescription: "Rédiger une ordonnance",
    writeTransmission: "Écrire une transmission",
    validateAlert: "Valider",
    resolveAlert: "Résoudre",
  },

  messages: {
    title: "Écrire à l’équipe",
    subtitle: "Hors urgence",
    newMessage: "Écrire",
    newConversation: "Nouvelle conversation",
    send: "Envoyer",
    placeholder: "Écrire à mon équipe…",
    noMessages: "Aucun message",
    noMessagesHint: "Écrivez pour une question non urgente.",
    noConversations: "Aucune conversation",
    you: "Vous",
    unread: "Non lu",
    yesterday: "Hier",
    today: "Aujourd'hui",
    selectConversation: "Sélectionnez une conversation",
    typeMessage: "Tapez votre message...",
    startConversation: "Écrire à mon équipe",
    teamAvailable: "",
    teamAvailabilityTitle: "",
    teamAvailabilityDesc: "",
    recipient: "Destinataire",
    subject: "Sujet",
    selectRecipient: "Sélectionner un destinataire",
    clinicians: "Cliniciens",
    patients: "Patients",
    conversationCreated: "Message prêt",
    conversationRemoved: "Conversation masquée",
    removeConversation: "Masquer cette conversation",
    removeConversationConfirm: "Masquer cette conversation de votre liste ?\nL’équipe la conserve dans le dossier.",
    loadError: "Chargement impossible",
    olderMessages: "Voir les messages précédents",
    defaultThreadName: "Mon équipe",
    attachFile: "Ajouter une pièce jointe",
    fileTooLarge: "Fichier trop volumineux (max 10 Mo)",
    fileSent: "Pièce jointe envoyée",
    sendError: "Envoi impossible",
    error: "Erreur",
    viewPhoto: "Voir la photo",
    photoAlt: "Photo envoyée",
    emergencyReminder: "Hana n’est pas un service d’urgence. En danger immédiat : appelez le 141 ou rendez-vous à l’hôpital le plus proche.",
    intentSymptom: "Symptôme",
    intentQuestion: "Question",
    intentTreatment: "Médicament",
    intentDocument: "Document",
    intentSymptomTemplate: "Je voudrais signaler un symptôme : ",
    intentQuestionTemplate: "J’ai une question : ",
    intentTreatmentTemplate: "J’ai une question sur mon traitement : ",
    intentDocumentTemplate: "Je voudrais parler d’un document médical : ",
  },

  documents: {
    title: "Documents",
    patientTitle: "Documents",
    subtitle: "",
    prescription: "Ordonnance",
    labResult: "Résultat laboratoire",
    report: "Compte rendu",
    imaging: "Imagerie",
    upload: "Envoyer un document",
    download: "Télécharger",
    noDocuments: "Aucun document disponible",
    noDocumentsTitle: "Aucun document",
    noDocumentsHint: "",
    type: "Type",
    date: "Date",
    description: "Description",
    uploadedBy: "Ajouté par",
    uploadDocument: "Envoyer un document",
    all: "Tous",
    uploadFirst: "Envoyer un document",
    downloadError: "Téléchargement impossible",
    selectFileAndType: "Choisissez un fichier et le type de document.",
    uploadSuccess: "Document envoyé",
    uploadError: "Envoi impossible",
    types: {
      prescription: "Ordonnance",
      lab_result: "Résultat d'analyse",
      medical_report: "Compte-rendu médical",
      imaging: "Imagerie",
      consent_form: "Consentement",
      other: "Autre",
    },
    uploadModalTitle: "Envoyer un document",
    sourcePatient: "Ajouté par vous",
    sourceLab: "Ajouté par le laboratoire",
    sourceImaging: "Ajouté par l’imagerie",
    sourceTeam: "Ajouté par l’équipe",
    sourceAvailable: "Document disponible",
    statusReceived: "Reçu",
    statusClassified: "Classé",
    statusAvailable: "Disponible",
    unsureType: "Je ne sais pas",
    unsureTypeHint: "",
    file: "Fichier",
    chooseFile: "Choisir un fichier",
    fileFormats: "PDF, JPG, PNG, DOC (max 10 Mo)",
    sending: "Envoi en cours...",
    send: "Envoyer",
  },

  appointments: {
    title: "Rendez-vous",
    subtitle: "",
    request: "Demander rendez-vous",
    requestAppointment: "Demander rendez-vous",
    newAppointment: "Nouveau rendez-vous",
    pendingRequests: "Demandes en attente",
    status: {
      PROPOSED: "En attente",
      CONFIRMED: "Confirmé",
      DECLINED: "Refusé",
      CANCELLED: "Annulé",
      COMPLETED: "Terminé",
    },
    noAppointments: "Aucun rendez-vous",
    date: "Date",
    time: "Heure",
    location: "Lieu",
    notes: "Notes",
    type: "Type de RDV",
    selectType: "Sélectionner...",
    types: {
      consultation: "Consultation",
      followup: "Suivi",
      chemotherapy: "Chimiothérapie",
      radiotherapy: "Radiothérapie",
      checkup: "Bilan",
      emergency: "Urgence",
    },
    confirm: "Confirmer",
    cancel: "Annuler",
    complete: "Terminer",
    confirmAppointment: "Confirmer le rendez-vous",
    cancelAppointment: "Annuler ce rendez-vous ?",
    selectDateTime: "Date et heure",
    referringDoctor: "Médecin référent du patient",
    selectDoctor: "Sélectionner un médecin",
    selectPatient: "Sélectionner un patient",
    searchPatient: "Rechercher un patient...",
    create: "Demander",
    // Patient actions for doctor-proposed appointments
    proposedByDoctor: "Proposition de rendez-vous",
    accept: "Accepter",
    decline: "Refuser",
    accepted: "Rendez-vous accepté",
    declined: "Rendez-vous refusé",
    dateToConfirm: "Date à confirmer",
    appointmentCreated: "Demande créée",
    appointmentConfirmed: "Rendez-vous confirmé",
    appointmentCancelled: "Rendez-vous annulé",
    appointmentCompleted: "Rendez-vous marqué comme terminé",
    loadError: "Erreur lors du chargement",
    requestSuccess: "Demande envoyée",
    notesPlaceholder: "Motif du rendez-vous…",
    declarativeBadge: "Clinique",
    declarativeTooltip: "Rendez-vous enregistré par la clinique.",
    error: "Erreur",
  },

  alerts: {
    title: "Alertes",
    status: {
      NEW: "Nouveau",
      IN_PROGRESS: "En cours",
      RESOLVED: "Résolu",
      ESCALATED: "Escaladé",
      VALIDATED: "Validé",
    },
    level: {
      ORANGE: "Avertissement",
      CRITICAL: "Critique",
    },
    noAlerts: "Aucune alerte",
    reasons: "Raisons",
    since: "Depuis",
    resolve: "Résoudre",
    escalate: "Escalader",
    validate: "Valider",
    resolution: "Résolution",
    outcome: "Issue",
    notes: "Notes",
    escalationReason: "Raison de l'escalade",
    resolveOrEscalate: "Résoudre ou escalader",
    resolveAlert: "Résoudre l'alerte",
    escalateAlert: "Escalader l'alerte",
    markAsResolved: "Marquer comme résolu",
    escalateToDoctor: "Escalader au médecin",
    outcomes: {
      NO_ACTION: "Pas d'action nécessaire",
      PHONE_CALL: "Appel téléphonique",
      APPOINTMENT: "Rendez-vous programmé",
      HOSPITALIZATION: "Hospitalisation",
      MEDICATION_CHANGE: "Modification traitement",
      OTHER: "Autre",
    },
  },

  nav: {
    home: "Accueil",
    patients: "Patients",
    alerts: "Alertes",
    messages: "Messages",
    documents: "Documents",
    appointments: "Rendez-vous",
    myRequests: "Mes demandes",
    profile: "Profil",
    settings: "Paramètres",
    logout: "Déconnexion",
    dashboard: "Tableau de bord",
    workqueue: "Relève IDE",
    workqueueSecretary: "Carnet de bord",
    orders: "Ordonnances",
    education: "Éducation",
    medicalRecord: "Dossier",
    clinicAdmin: "Admin Clinique",
    reviews: "À valider",
    triage: "Bilans à trier",
  },

  admin: {
    dashboard: "Administration",
    manageUsers: "Gestion des utilisateurs",
    manageClinics: "Gestion des cliniques",
    managePatients: "Gestion des patients",
    stats: "Statistiques",
    billing: "Facturation",
    audios: "Gestion des audios",
    kpi: "Indicateurs",
    users: "Utilisateurs",
    clinics: "Cliniques",
    groups: "Groupes",
    createUser: "Créer un utilisateur",
    createClinic: "Créer une clinique",
    createPatient: "Créer un patient",
    editUser: "Modifier l'utilisateur",
    editClinic: "Modifier la clinique",
    editPatient: "Modifier le patient",
    deactivate: "Désactiver",
    activate: "Activer",
    resetPassword: "Réinitialiser mot de passe",
    newPassword: "Nouveau mot de passe",
    userCreated: "Utilisateur créé",
    userUpdated: "Utilisateur mis à jour",
    userDeactivated: "Utilisateur désactivé",
    userActivated: "Utilisateur réactivé",
    passwordReset: "Mot de passe réinitialisé",
    clinicCreated: "Clinique créée",
    patientCreated: "Patient créé",
    patientUpdated: "Patient mis à jour",
    firstName: "Prénom",
    lastName: "Nom",
    email: "Email",
    phone: "Téléphone",
    role: "Rôle",
    clinic: "Clinique",
    group: "Groupe",
    dateOfBirth: "Date de naissance",
    address: "Adresse",
    pathology: "Pathologie",
    treatment: "Traitement",
    height: "Taille (cm)",
    referringDoctor: "Médecin référent",
    selectClinic: "Sélectionner une clinique",
    selectRole: "Sélectionner un rôle",
    selectDoctor: "Sélectionner un médecin",
    noUsersFound: "Aucun utilisateur trouvé",
    noClinicsFound: "Aucune clinique trouvée",
    noPatientsFound: "Aucun patient trouvé",
    showInactive: "Afficher inactifs",
    clinicName: "Nom de la clinique",
    clinicAddress: "Adresse de la clinique",
  },

  orders: {
    laboratoire: "Laboratoire",
    pharmacie: "Pharmacie",
    imagerie: "Imagerie",
    status: {
      RECEIVED: "Reçu",
      IN_PROGRESS: "En cours",
      COMPLETED: "Terminé",
    },
    accept: "Accepter",
    complete: "Terminer",
    uploadResult: "Téléverser résultat",
    homeDelivery: "Livraison à domicile",
    newOrders: "Nouvelles commandes",
    inProgress: "En cours",
    completed: "Terminées",
  },

  // Patient detail pages
  patientDetail: {
    overview: "Vue d'ensemble",
    checkins: "Check-ins",
    alerts: "Alertes",
    transmissions: "Transmissions",
    documents: "Documents",
    info: "Informations",
    pathology: "Pathologie",
    treatment: "Traitement",
    referringDoctor: "Médecin référent",
    phone: "Téléphone",
    dateOfBirth: "Date de naissance",
    address: "Adresse",
    height: "Taille",
    weight: "Poids",
    lastCheckin: "Dernier check-in",
    noCheckins: "Aucun check-in",
    urgentSymptoms: "Symptômes urgents",
    mainSymptoms: "Symptômes principaux",
    vitals: "Constantes vitales",
    charts: "Graphiques",
    evolution: "Évolution",
    temperatureEvolution: "Évolution de la température",
    heartRateEvolution: "Évolution du pouls",
    bloodPressureEvolution: "Évolution de la tension artérielle",
    spo2Evolution: "Évolution de l'oxygène (SpO2)",
    weightEvolution: "Évolution du poids",
    noChartData: "Pas assez de données pour afficher les graphiques",
    chartDataWillAppear: "Les graphiques apparaîtront après quelques check-ins",
    feverThreshold: "Seuil fièvre",
    lowThreshold: "Seuil bas",
    systolic: "Systolique",
    diastolic: "Diastolique",
    imc: "IMC",
    changeStatus: "Changer le statut",
    newStatus: "Nouveau statut",
    transmissionRequired: "Une transmission est obligatoire pour ce changement",
    writeTransmission: "Écrire une transmission...",
    statusChanged: "Statut mis à jour",
    editPatient: "Modifier le patient",
    callPatient: "Appeler le patient",
    requestAppointment: "Demander un RDV",
    newTransmission: "Nouvelle transmission",
    writeTransmissionPlaceholder: "Écrire une transmission...",
    transmissionSent: "Transmission envoyée",
    noTransmissions: "Aucune transmission",
    noDocuments: "Aucun document",
    noAlerts: "Aucune alerte",
    uploadDocument: "Ajouter un document",
    documentUploaded: "Document téléversé",
  },

  // Common form labels
  form: {
    firstName: "Prénom",
    lastName: "Nom",
    email: "Email",
    phone: "Téléphone",
    password: "Mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    save: "Enregistrer",
    cancel: "Annuler",
    submit: "Soumettre",
    required: "Ce champ est obligatoire",
    invalidEmail: "Email invalide",
    invalidPhone: "Numéro invalide",
    passwordTooShort: "Le mot de passe doit contenir au moins 8 caractères",
  },

  // Error messages
  errors: {
    generic: "Une erreur est survenue",
    network: "Erreur de connexion",
    unauthorized: "Non autorisé",
    forbidden: "Accès interdit",
    notFound: "Non trouvé",
    validation: "Erreur de validation",
    serverError: "Erreur serveur",
  },

  // Time and dates
  time: {
    today: "Aujourd'hui",
    yesterday: "Hier",
    tomorrow: "Demain",
    thisWeek: "Cette semaine",
    lastWeek: "Semaine dernière",
    thisMonth: "Ce mois",
    lastMonth: "Mois dernier",
    ago: "il y a",
    in: "dans",
    minutes: "minutes",
    hours: "heures",
    days: "jours",
    weeks: "semaines",
    months: "mois",
  },

  // Studies module
  studies: {
    title: "Études cliniques",
    createStudy: "Créer une étude",
    studyTitle: "Titre de l'étude",
    sponsor: "Sponsor",
    description: "Description",
    status: "Statut",
    startDate: "Date de début",
    endDate: "Date de fin",
    inclusionCriteria: "Critères d'inclusion",
    questionnaires: "Questionnaires",
    visits: "Visites",
    enrollments: "Enrôlements",
    enrolled: "Enrôlé",
    eligible: "Éligible",
    noStudies: "Aucune étude",
    enrollPatient: "Enrôler un patient",
    viewDetails: "Voir les détails",
    dashboard: "Tableau de bord",
    adherence: "Adhérence",
    exportData: "Exporter les données",
    pendingQuestionnaires: "Questionnaires en attente",
    completeQuestionnaire: "Compléter le questionnaire",
    skipQuestionnaire: "Passer",
    questionnaireCompleted: "Questionnaire complété",
    scores: "Scores",
    visitSchedule: "Calendrier des visites",
    cancerType: "Type de cancer",
    minAge: "Âge minimum",
    maxAge: "Âge maximum",
    treatmentType: "Type de traitement",
    addVisit: "Ajouter une visite",
    visitName: "Nom de la visite",
    dayOffset: "Jour (depuis enrôlement)",
    selectQuestionnaires: "Sélectionner les questionnaires",
    studyCreated: "Étude créée",
    patientEnrolled: "Patient enrôlé",
    active: "Active",
    completed: "Terminée",
    draft: "Brouillon",
    paused: "En pause",
    step3Title: "Questionnaire d'étude",
    step3Desc: "Vous avez un questionnaire dans le cadre d'une étude clinique.",
    progress: "Progression",
    question: "Question",
    of: "sur",
    studyBadge: "Étude",
    noEligiblePatients: "Aucun patient éligible",
    findEligible: "Rechercher les éligibles",
    consent: "Consentement",
    consentObtained: "Consentement obtenu",
  },

  // Education module
  education: {
    title: "Conseils de soin",
    subtitle: "Des conseils courts, choisis pour votre parcours.",
    recommended: "À lire",
    explore: "Thèmes",
    myProgress: "Progression",
    myRecent: "Consultés récemment",
    contents: "conseils",
    consultedProgress: "{completed} sur {total} consultés",
    completed: "Consulté",
    inProgress: "En cours",
    toWatch: "À voir",
    understood: "J'ai compris",
    askQuestion: "Question",
    startQuestionnaire: "Questionnaire",
    keyPoints: "À retenir",
    backToEducation: "Retour",
    questionSent: "Question envoyée à l’équipe",
    noContent: "Aucun conseil disponible",
    contentWillAppear: "Les conseils apparaîtront ici.",
    categoryContentsWillAppear: "Les conseils de ce thème apparaîtront ici.",
    contentNotFound: "Conseil non trouvé",
    viewed: "Vu",
    understoodThanks: "Noté",
    askComprehension: "Ce conseil est-il clair ?",
    understandRecorded: "Réponse enregistrée",
    recordError: "Enregistrement impossible",
    loadContentError: "Conseil indisponible",
    loadContentsError: "Conseils indisponibles",
    pleaseTypeQuestion: "Saisissez votre question",
    sendQuestionError: "Question non envoyée",
    questionModalTitle: "Question à l’équipe",
    questionModalDesc: "",
    contentLabel: "Conseil",
    questionPlaceholder: "Votre question…",
    sendingQuestion: "Envoi…",
    sendQuestion: "Envoyer",
    questionnaireGood: "Compréhension confirmée.",
    questionnaireNeedsReview: "Certains points peuvent être relus.",
    questionnairePoor: "Relisez ce conseil quand vous le souhaitez.",
    correctAnswers: "bonnes réponses",
    closeBtn: "Fermer",
    sendingQuestionnaire: "Envoi...",
    submitAnswers: "Valider",
    questionnaireCompleted: "Questionnaire envoyé",
    questionnaireSubmitError: "Envoi impossible",
    categories: {
      BIENVENUE: "Bienvenue",
      TRAITEMENT: "Traitement",
      NUTRITION: "Nutrition",
      EFFETS_SECONDAIRES: "Effets secondaires",
      SIGNES_ALERTE: "Signes d'alerte",
      BIEN_VIVRE: "Bien-être",
      GESTION_SYMPTOMES: "Gestion des symptômes",
    },
    categoryDescriptions: {
      BIENVENUE: "Découvrez votre parcours de soins",
      TRAITEMENT: "Comprendre votre traitement",
      NUTRITION: "Conseils alimentaires",
      EFFETS_SECONDAIRES: "Gérer les effets secondaires",
      SIGNES_ALERTE: "Quand contacter l'équipe",
      BIEN_VIVRE: "Qualité de vie au quotidien",
      GESTION_SYMPTOMES: "Soulager vos symptômes",
    },
  },

  biology: {
    title: "Envoyer mes résultats",
    subtitle: "Avant traitement — maximum {n} pages",
    sampleDate: "Date du prélèvement",
    pagesAdded: "page(s) ajoutée(s)",
    cameraBtn: "Photo",
    galleryBtn: "Galerie",
    pdfBtn: "PDF",
    photoHint: "Ajoutez chaque page du bilan, ou un PDF.",
    sendBilan: "Envoyer le bilan",
    sendPdf: "Envoyer le PDF",
    sending: "Envoi…",
    pdfBadge: "PDF",
    maxPagesReached: "Limite de pages maximum atteinte",
    pdfTooLarge: "PDF trop volumineux (max 20 Mo)",
    onlyOnePdf: "Envoyez un seul PDF à la fois, ou des photos.",
    removePhotosFirst: "Retirez d'abord vos photos avant d'ajouter un PDF.",
    removePdfFirst: "Retirez d'abord le PDF avant d'ajouter des photos.",
    imageError: "Erreur traitement image",
    imageProcessing: "Traitement des images...",
    needAtLeastOnePage: "Ajoutez une page ou un PDF",
    uploading: "Envoi du bilan…",
    uploadSuccess: "Bilan envoyé",
    uploadSuccessDesc: "",
    uploadError: "Envoi impossible. Veuillez réessayer",
    removePdfAria: "Retirer PDF",
    removePageAria: "Supprimer",
    closeAria: "Fermer",
  },
};

export default fr;
